
import { Options, Vue } from 'vue-class-component';
import GlobalStore from "@/utils/global-store";
import Alert from "@/components/Alert.vue";
import LoginModal from "@/components/modals/LoginModal.vue";
import FieldError from "@/components/forms/FieldError.vue";

type Form = {
    email: string,
    email_confirmation: string,
    prename: string,
    surname: string,
};

type FormErrors = Record<string, string[]>;

export interface StepUserGuestData {
    email: string,
    email_confirmation: string,
    prename: string,
    surname: string,
}

@Options({
    props: {
        /*
        step: {
            type: Number,
            required: true,
        },
        */
        isCurrent: {
            type: Boolean,
            required: false,
            default: false,
        },
        validationErrors: {
            type: Object,
            required: false,
            default: {},
        },
    },
    components: {
        Alert,
        FieldError,
        LoginModal,
    },
    emits: [
        'valid',
        'invalid',
        'data',
    ],
    /*emits: {
        success: (value: any) => value === null || typeof value === 'string' || Array.isArray(value),
    },*/
})
export default class StepUserGuest extends Vue {
    isCurrent!: boolean
    validationErrors!: FormErrors

    emailRegex = /^\S+@\S+\.\S+$/
    showEmailError = false
    showEmailConfirmationError = false

    get hasValidationErrors() {
        return Object.keys(this.validationErrors).length > 0;
    }

    loginModalShown = false

    form: Form = {
        email: '',
        email_confirmation: '',
        prename: '',
        surname: '',
    }

    get emailValid() {
        return this.emailRegex.test(this.form.email);
    }

    get formValid() {
        if( !this.form.email || !this.emailValid ) {
            return false;
        }
        if( this.form.email !== this.form.email_confirmation ) {
            return false;
        }
        if( !this.form.prename || !this.form.surname ) {
            return false;
        }

        return true;
    }

    get stepData() : StepUserGuestData {
        return { ...this.form };
    }

    get loggedIn() {
        return GlobalStore.data.loggedIn.value;
    }

    emitState() {
        if( this.loggedIn || this.formValid ) {
            this.$emit('data', this.stepData);
            this.$emit('valid');
        }
        else {
            this.$emit('data', null);
            this.$emit('invalid');
        }
    }

    mounted() {
        this.$watch('loggedIn', this.emitState, { immediate: true });
        // this.$watch('formValid', this.emitState);

        this.$watch('form', this.emitState, { deep: true });
    }
}
